import {
  postJsonData,
  fetchJsonData,
  postJsonRawResponse,
} from '../../../global/data/service'
import { getItem } from '../../../global/data/synch-storage'
import {
  setCorelationIds,
  getCorelationIds,
} from '../../SelfService/Data/SelfServiceDataSource.js'
import {
  getLoginData,
  getLoginDataError,
  getMfaResponse,
  getMfaResponse2,
  getRiskAdviceAllow,
} from './response-mock.js'
import profileData from '../../../../test/components/Navigation/mock-data/mock-profile-response.json'
import { isLocal } from '../../../global/environments'

const LOCAL_DEBUG = true

export async function login(username, password, websession_id, tmx_id) {
  try {
    const url = '/adv.svc/login'
    const corelationId = setCorelationIds()
    const headers = getHeaders()
    headers.websession_id = websession_id
    headers.tmx_id = tmx_id
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id

    const data = {
      userId: username,
      password: password,
      deviceSignature: window?.getDeviceSignature(),
    }
    if (isLocal() && LOCAL_DEBUG) {
      if (password === 'Abcd1234!' || password === '$Testing1') {
        return getLoginData(password)
      } else {
        return getLoginDataError(password)
      }
    } else {
      return postJsonRawResponse(url, data, headers)
    }
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export async function postMFA(id, activityType) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    activityType && (headers['act_type'] = activityType)

    const url = '/advexp.svc/mfa'

    const data = {
      channel: id,
    }
    if (isLocal() && LOCAL_DEBUG) {
      if (id === 'KBA') {
        return getMfaResponse2()
      } else {
        return getMfaResponse()
      }
    } else {
      return postJsonData(url, data, headers)
    }
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export function postResetPassword(data) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const url = '/advexp.svc/changePassword'
    return postJsonData(url, data, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

/**
 * PUT now changed to a POST
 * @param {*} data
 * @returns
 */
export function putResetPassword(data) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const url = '/advexp.svc/changePassword'
    return postJsonData(url, data, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export function postRiskAdvice(data) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    headers.action = 'changeTempPwd'

    const url = '/advexp.svc/riskAdvice'
    if (isLocal() && LOCAL_DEBUG) {
      return getRiskAdviceAllow()
      // return getRiskAdviceOTPOnly()
    } else {
      return postJsonRawResponse(url, data, headers)
    }
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export function validateSSOUsername(userId) {
  try {
    const url = '/adv.svc/validateuser?id=' + encodeURIComponent(userId)
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    return fetchJsonData(url, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export function getSecureProfile() {
  try {
    const url = '/adv.svc/secure/profile'
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    if (isLocal() && LOCAL_DEBUG) {
      return profileData
    } else {
      return fetchJsonData(url, headers)
    }
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

function getHeaders() {
  const apiToken = getItem('apiToken')
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    apitoken: apiToken,
    deviceid: window?.getDeviceId(),
    'X-Requested-With': 'XMLHttpRequest',
  }
}

export async function postNoAddressChange(data) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const url = '/adv.svc/secure/continuefirmid'
    return postJsonData(url, data, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export async function postUpdateUsrContact(data, tmx_id, websession_id) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.websession_id = websession_id
    headers.tmx_id = tmx_id
    headers.profiled_url = `${window?.origin}/login`
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const url = '/adv.svc/updateUserContact'
    return postJsonRawResponse(url, data, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}

export async function postSubscribeUser(apiToken, data, tmx_id, websession_id) {
  try {
    const headers = getHeaders()
    const corelationId = getCorelationIds()
    headers.apitoken = apiToken
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    headers.tmx_id = tmx_id
    headers.websession_id = websession_id
    const url = '/adv.svc/subscribeUser'
    return postJsonRawResponse(url, data, headers)
    /* eslint-disable-next-line no-empty */
  } catch (error) {}
}
